import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'underscore';
import BtnFavorite from 'components/forms/BtnFavorite';
import { favoriteDel, favoriteAdd } from 'services/api/user/favorite';
import { converter } from 'helpers/converter';
import Utils from 'utils/Utils';
import { fetchContentList } from 'action-creators/carousel';
import { ANONYMOUS_USER } from 'constants.js';
import { store } from 'store.js';
import SpecialItem from './SpecialItem';

export class SpecialCarousel extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      __id: Utils.createId(),
      groups: [],
      width: window.innerWidth,
      pan: 0,
      scrollTransform: '',
      userType: 'anonymous',
    };
    this._interval = null;
    this.fetchData = this.fetchData.bind(this);
    // debounce resize event listener
    this.onResize = _.debounce(this.onResize.bind(this), 75);
    this.switchSlide = this.switchSlide.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.fetchData();
    $(window).on('resize', this.onResize);
  }

  componentWillUnmount() {
    // some cleanup;
    $(window).off('resize', this.onResize);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const carousel = nextProps.carousel.findById[this.state.__id] || {};
    const groups = carousel.groups || [];
    this.setState({
      userType: Utils.userStatusParse(this.props.user),
      groups,
    });
  }

  fetchData() {
    const {
      carouselData: { url },
      config,
    } = this.props;

    const opts = {
      _id: this.state.__id,
      url,
      config,
    };
    this.props.fetch(opts);
  }

  onResize(e) {
    this.setState({
      width: e.target.innerWidth,
      scrollTransform: '',
    });
  }

  getWidth(width) {
    return width > 992 ? 1744 : 'auto';
  }

  switchSlide(e) {
    const $el = $(e.target);
    const dir = $el.data('dir');
    const maxPan = this.refs.panArea.clientWidth - this.state.width;
    const pan = (dir === 'left' ? 0 : maxPan) + 'px';

    $(this.refs.panArea.parentElement).animate(
      {
        scrollLeft: pan,
      },
      150,
    );
  }

  async onFavoriteClick(isFavorited) {
    const params = {
      object_id: this.group.id,
      user_hash: this.userhash,
      object_type: 1,
    };

    if (!isFavorited) store.dispatch(favoriteAdd(params));
    else store.dispatch(favoriteDel(params));
  }

  render() {
    const [first, ...rest] = this.state.groups;
    const {
      carouselData: data,
      user,
      config,
      translations,
      size,
      sizeAlt,
      favorites,
    } = this.props;

    const hasSession = user.userType !== ANONYMOUS_USER;
    if (this.state.groups.length < 1) {
      return null;
    }

    const firstRedirect = Utils.buildRedirect({
      content: first,
      userType: this.state.userType,
      urlPlayer: config.urlPlayer,
    });

    const labelDetails = converter.convertApaUnicode(
      translations,
      'common_mas_info',
      'Ver detalles',
    );

    const btnProps = {
      style: {
        backgroundColor: `#${data.buttoncolor}`,
        color: `#${data.fontcolor}`,
        borderColor: `#${data.fontcolor}`,
      },
    };

    return (
      <div id={`${data.id}_carrousel`} className="container2">
        <div className="jcarousel jcarousel-3 horizontal">
          <div
            onClick={this.switchSlide}
            data-dir="left"
            className="scrollinghotspotleft hidden-sm"
          >
            <i className="fa fa-chevron-left fa-2x" />
          </div>
          <div
            onClick={this.switchSlide}
            data-dir="right"
            className="scrollinghotspotright hidden-sm"
          >
            <i className="fa fa-chevron-right fa-2x" />
          </div>

          <div className="scrollwrapper">
            <div
              ref="panArea"
              className="scrollablearea"
              style={{
                width: this.getWidth(this.state.width),
              }}
            >
              <div className="jcarousel-container jcarousel-container-1">
                <SpecialItem
                  d={first}
                  styles={data}
                  size={size}
                  sizeAlt={sizeAlt}
                  redirect={firstRedirect}
                >
                  {hasSession && [
                    <div className="col-sm-6" key="info__MAIN">
                      <div className="col-lg-12 col-md-12 col-sm-12 padding-top-1 padding-bottom-2">
                        <Link
                          to={firstRedirect.redirectUrl}
                          style={btnProps.style}
                          className="btn btn-default item-fanbutton"
                        >
                          {labelDetails}
                        </Link>
                      </div>
                    </div>,
                    <div className="col-sm-6" key="plus__MAIN">
                      <BtnFavorite
                        onClick={this.onFavoriteClick}
                        group={first}
                        translations={translations}
                        favorites={favorites}
                        user={user}
                        btnProps={btnProps}
                      />
                    </div>,
                  ]}
                </SpecialItem>
              </div>
              <div className="jcarousel-container jcarousel-container-2">
                {rest.map((d, i) => {
                  const redirect = Utils.buildRedirect({
                    content: d,
                    userType: this.state.userType,
                    urlPlayer: config.urlPlayer,
                  });
                  return (
                    <SpecialItem
                      key={i}
                      row
                      d={d}
                      styles={data}
                      size={size}
                      sizeAlt={sizeAlt}
                      redirect={redirect}
                    >
                      {hasSession && [
                        <div className="col-sm-6" key={`info${i}`}>
                          <div className="col-lg-12 col-md-12 col-sm-12 padding-top-1 padding-bottom-2">
                            <Link
                              to={redirect.redirectUrl}
                              style={btnProps.style}
                              className="btn btn-default item-fanbutton"
                            >
                              {labelDetails}
                            </Link>
                          </div>
                        </div>,
                        <div className="col-sm-6" key={`plus${i}`}>
                          <BtnFavorite
                            onClick={this.onFavoriteClick}
                            group={d}
                            translations={translations}
                            favorites={favorites}
                            user={user}
                            btnProps={btnProps}
                          />
                        </div>,
                      ]}
                    </SpecialItem>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SpecialCarousel.propTypes = {
  config: PropTypes.object,
  size: PropTypes.string,
  sizeAlt: PropTypes.string,
  user: PropTypes.object,
  translations: PropTypes.object,
  favorites: PropTypes.array,
  carouselData: PropTypes.object.isRequired,
  fetch: PropTypes.func.isRequired,
};

SpecialCarousel.defaultProps = {
  size: 'image_large',
  sizeAlt: 'image_medium',
  config: {},
};

const mapStateToProps = state => ({
  config: state.config,
  carousel: state.carousel,
  user: state.user,
  translations: state.translations,
  favorites: state.favorites,
});

const mapDispatchToProps = {
  fetch: fetchContentList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SpecialCarousel);
